import BigNumber from 'bignumber.js';
import type { FlipCoinGame, FlipCoinPlayer } from '~/types/FlipCoin';

export const getSPAmount = (
  betAmountSummedWithTotal: number,
  seasonPointsMultiplier: number,
  totalSPInCurrentPeriod: number
) => {
  console.log('betAmountSummedWithTotal', betAmountSummedWithTotal);
  console.log('seasonPointsMultiplier', seasonPointsMultiplier);
  console.log('totalSPInCurrentPeriod', totalSPInCurrentPeriod);
  return BigNumber(betAmountSummedWithTotal)
    .sqrt()
    .multipliedBy(seasonPointsMultiplier)
    .minus(totalSPInCurrentPeriod)
    .integerValue(BigNumber.ROUND_FLOOR)
    .toNumber();
};

export const getUserData = (row: FlipCoinGame, isWinner: boolean = false): FlipCoinPlayer => {
  const players = [row?.ownerPlayer, row?.joinerPlayer];
  const winner = row?.winner;

  return players.find((item) =>
    isWinner ? item?.userAddress === winner : item?.userAddress !== winner
  ) as FlipCoinPlayer;
};
